import React from 'react'
import { Label } from 'semantic-ui-react'

import { format } from 'date-fns'
import Popup from 'shared/components/Popup'

export default function ClosedSurveyLabel({ className, closed_at }) {
  const formattedDate = format(new Date(closed_at), "'Survey was closed on' MMM d, yyyy")

  return (
    <Popup basic tooltip={formattedDate}>
      <Label className={className}>Closed</Label>
    </Popup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ClosedSurveyLabel/index.js